
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bKsCn", function(module, exports) {
/* TasksReportMacroRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * GraphQL-backed Tasks Report macro renderer.
 *
 * Drop-in replacement for TasksReportMacroRenderer that fetches task data via
 * the `inlineTasks` AGG GraphQL query instead of the legacy REST endpoint.
 *
 * Usage: wire this component into the extension handler instead of
 * TasksReportMacroRenderer once you're ready to flip the feature gate.
 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $bQm3c = parcelRequire("bQm3c");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $rPmsQ = parcelRequire("rPmsQ");

/**
 * GraphQL-backed replacement for useTasksReportData.
 *
 * Uses the `inlineTasks` AGG query (same one powering Tasks Home) instead of the
 * legacy REST endpoint `/rest/inlinetasks/1/task-report`.
 *
 * Pagination: cursor-based ("load more") — the AGG schema does not expose a
 * `totalCount` field on the inlineTasks connection, so page-index pagination is
 * not possible without a backend change. The component layer should render a
 * "Load more" button driven by `hasNextPage`.
 */ 



var $jMyy4 = parcelRequire("jMyy4");


var $7QM6o = parcelRequire("7QM6o");


var $hJ6Qq = parcelRequire("hJ6Qq");


var $1NBp8 = parcelRequire("1NBp8");

const $45ad25443ac72851$var$PEOPLE_DIRECTORY_PATH = (0, $1NBp8.PEOPLE_DIRECTORY).toUrl().replace(/\/$/, '');
const $45ad25443ac72851$var$WIKI_CONTEXT_PATH = (0, $1NBp8.WIKI).toUrl().replace(/\/$/, '');
const $45ad25443ac72851$export$dbeb5d178380300f = (accountId)=>`${$45ad25443ac72851$var$PEOPLE_DIRECTORY_PATH}/${accountId}?ref=confluence`;
const $45ad25443ac72851$export$ffc2c8370739f57a = (base, webUi)=>{
    if (!base || !webUi) return null;
    return `${base}${webUi}`;
};
function $45ad25443ac72851$export$c254a30a66ea69b8(url) {
    if (!url) return null;
    if (/^https?:\/\//i.test(url) || url === $45ad25443ac72851$var$WIKI_CONTEXT_PATH || url.startsWith(`${$45ad25443ac72851$var$WIKI_CONTEXT_PATH}/`)) return url;
    if (url.startsWith('/')) return `${$45ad25443ac72851$var$WIKI_CONTEXT_PATH}${url}`;
    return `${$45ad25443ac72851$var$WIKI_CONTEXT_PATH}/${url}`;
}



var $fzKPX = parcelRequire("fzKPX");

function $35db60b89e0f9281$var$normaliseContainerLabels(labels) {
    if (!labels || labels.length === 0) return [];
    const normalisedLabels = [];
    for (const containerLabel of labels){
        if (!containerLabel) continue;
        const labelValue = containerLabel.label;
        if (!labelValue) continue;
        normalisedLabels.push(labelValue);
    }
    return normalisedLabels;
}
/** Normalise raw GraphQL task into the public TaskEntity shape. */ function $35db60b89e0f9281$var$normaliseTask(raw) {
    const container = raw.container ?? null;
    let contentId = null;
    let title = null;
    let url = null;
    let spaceUrl = null;
    let spaceName = null;
    let labels = [];
    if (container) {
        if (container.__typename === 'ConfluencePage') {
            contentId = container.pageId ?? null;
            title = container.title ?? null;
            url = (0, $45ad25443ac72851$export$ffc2c8370739f57a)(container.links?.base, container.links?.webUi);
            spaceName = container.space?.name ?? null;
            spaceUrl = (0, $45ad25443ac72851$export$ffc2c8370739f57a)(container.space?.links?.base, container.space?.links?.webUi);
            labels = $35db60b89e0f9281$var$normaliseContainerLabels(container.labels);
        } else if (container.__typename === 'ConfluenceBlogPost') {
            contentId = container.blogPostId ?? null;
            title = container.title ?? null;
            url = (0, $45ad25443ac72851$export$ffc2c8370739f57a)(container.links?.base, container.links?.webUi);
            spaceName = container.space?.name ?? null;
            spaceUrl = (0, $45ad25443ac72851$export$ffc2c8370739f57a)(container.space?.links?.base, container.space?.links?.webUi);
            labels = $35db60b89e0f9281$var$normaliseContainerLabels(container.labels);
        }
    }
    let normalisedStatus = null;
    if (raw.status === 'COMPLETE') normalisedStatus = 'COMPLETE';
    else if (raw.status === 'INCOMPLETE') normalisedStatus = 'INCOMPLETE';
    return {
        id: raw.id,
        // taskId comes back as a string ID and is reused by the completion mutation.
        taskId: raw.taskId ?? null,
        status: normalisedStatus,
        adf: raw.body?.adf ?? null,
        dueAt: raw.dueAt ?? null,
        createdAt: raw.createdAt ?? null,
        completedAt: raw.completedAt ?? null,
        assignedTo: raw.assignedTo ? {
            accountId: raw.assignedTo.accountId,
            displayName: raw.assignedTo.displayName ?? null,
            avatarPath: raw.assignedTo.profilePicture?.path ?? null
        } : null,
        createdBy: raw.createdBy ? {
            accountId: raw.createdBy.accountId,
            displayName: raw.createdBy.displayName ?? null
        } : null,
        container: container ? {
            contentId: contentId,
            title: title,
            url: url,
            spaceUrl: spaceUrl,
            spaceName: spaceName,
            labels: labels
        } : null
    };
}
function $35db60b89e0f9281$var$matchesRequestedStatus(task, requestedStatus) {
    if (task.status === null) return true;
    if (!requestedStatus) return true;
    if (requestedStatus === 'complete') return task.status === 'COMPLETE';
    return task.status === 'INCOMPLETE';
}
function $35db60b89e0f9281$export$6e0f38053ef16fcf({ params: params, cloudId: cloudId }) {
    // Include sortBy and reverseSort so a sort change triggers a new server request
    // with the correct sortParameters rather than a client-side re-sort.
    const queryParams = (0, $cozmU.useMemo)(()=>({
            columns: params.columns,
            spaces: params.spaces,
            pages: params.pages,
            assignees: params.assignees,
            creators: params.creators,
            labels: params.labels,
            status: params.status,
            duedateFrom: params.duedateFrom,
            duedateTo: params.duedateTo,
            createddateFrom: params.createddateFrom,
            createddateTo: params.createddateTo,
            pageSize: params.pageSize,
            sortBy: params.sortBy,
            reverseSort: params.reverseSort
        }), [
        params.columns,
        params.assignees,
        params.createddateFrom,
        params.createddateTo,
        params.creators,
        params.duedateFrom,
        params.duedateTo,
        params.labels,
        params.pageSize,
        params.pages,
        params.reverseSort,
        params.sortBy,
        params.spaces,
        params.status
    ]);
    const rawSpaceId = (0, $7QM6o.useSpaceId)();
    const currentSpaceId = (0, $cozmU.useMemo)(()=>{
        if (!rawSpaceId) return undefined;
        const parsedSpaceId = Number.parseInt(rawSpaceId, 10);
        return Number.isNaN(parsedSpaceId) ? undefined : parsedSpaceId;
    }, [
        rawSpaceId
    ]);
    const explicitSpaces = (0, $cozmU.useMemo)(()=>(0, $fzKPX.parseCommaSeparatedValues)(params.spaces), [
        params.spaces
    ]);
    // Split the explicit spaces param into two buckets:
    // - spaceIds: tokens (@self, currentSpace()) and numeric IDs — resolved synchronously
    // - spaceKeys: human-readable keys (e.g. "ENG", "~DS") — passed directly to the
    //   AGG query which resolves them server-side (InlineTasksByMetadata.spaceKeys field)
    const spaceIds = (0, $cozmU.useMemo)(()=>(0, $fzKPX.toLongIds)(explicitSpaces, currentSpaceId), [
        explicitSpaces,
        currentSpaceId
    ]);
    const spaceKeys = (0, $cozmU.useMemo)(()=>(explicitSpaces ?? []).filter((value)=>value !== (0, $fzKPX.CURRENT_SPACE_TOKEN) && value !== (0, $fzKPX.SELF_SPACE_TOKEN) && !/^\d+$/.test(value.startsWith('~') ? value.slice(1) : value)), [
        explicitSpaces
    ]);
    const pageIds = (0, $cozmU.useMemo)(()=>(0, $fzKPX.toLongIdStrings)((0, $fzKPX.parseCommaSeparatedValues)(params.pages)), [
        params.pages
    ]);
    const hasAnyScopeFilter = spaceIds.length > 0 || spaceKeys.length > 0 || pageIds.length > 0;
    // Memoize the first-page taskQuery. Sort changes (queryParams) reset the cursor
    // to null so the server re-runs the query from the beginning with the new order.
    const taskQuery = (0, $cozmU.useMemo)(()=>(0, $fzKPX.buildTaskQueryMetadata)(queryParams, spaceIds, spaceKeys, null), [
        queryParams,
        spaceIds,
        spaceKeys
    ]);
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $hJ6Qq.default), {
        variables: {
            taskQuery: taskQuery,
            cloudId: cloudId
        },
        skip: !hasAnyScopeFilter,
        fetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "tasks-report-macro"
    });
    const rawTasks = (0, $cozmU.useMemo)(()=>data?.inlineTasks?.inlineTasks ?? [], [
        data?.inlineTasks?.inlineTasks
    ]);
    const safePageSize = queryParams.pageSize > 0 ? queryParams.pageSize : 1;
    const lastFetchedBatchSize = (0, $cozmU.useMemo)(()=>{
        if (rawTasks.length === 0) return 0;
        const remainder = rawTasks.length % safePageSize;
        return remainder === 0 ? safePageSize : remainder;
    }, [
        rawTasks.length,
        safePageSize
    ]);
    // A non-null endCursor means the server has more pages beyond what we've received.
    // The AGG schema does not expose pageInfo.hasNextPage, so endCursor is the proxy.
    const endCursor = data?.inlineTasks?.endCursor ?? null;
    // Guard against inconsistent payloads: if the most recently fetched batch
    // is smaller than pageSize, there is no additional page to fetch.
    const hasNextPage = endCursor !== null && lastFetchedBatchSize >= safePageSize;
    // Keep a local status guard so the table stays correct even if the server/cache
    // transiently returns mixed statuses while filters are switching.
    const tasks = (0, $cozmU.useMemo)(()=>{
        const normalizedTasks = [];
        for (const rawTask of rawTasks){
            if (!rawTask) continue;
            const task = $35db60b89e0f9281$var$normaliseTask(rawTask);
            if ($35db60b89e0f9281$var$matchesRequestedStatus(task, params.status)) normalizedTasks.push(task);
        }
        return normalizedTasks;
    }, [
        rawTasks,
        params.status
    ]);
    // Fetch the next cursor page and append its tasks to the accumulated list.
    const loadMore = (0, $cozmU.useCallback)(()=>{
        if (!endCursor || !fetchMore || !hasAnyScopeFilter) return;
        fetchMore({
            variables: {
                taskQuery: (0, $fzKPX.buildTaskQueryMetadata)(queryParams, spaceIds, spaceKeys, endCursor),
                cloudId: cloudId
            },
            updateQuery (previousResult, { fetchMoreResult: fetchMoreResult }) {
                if (!fetchMoreResult?.inlineTasks) return previousResult;
                const previousTasks = previousResult?.inlineTasks?.inlineTasks ?? [];
                const newTasks = fetchMoreResult.inlineTasks.inlineTasks ?? [];
                return {
                    ...previousResult,
                    inlineTasks: {
                        ...fetchMoreResult.inlineTasks,
                        inlineTasks: [
                            ...previousTasks,
                            ...newTasks
                        ]
                    }
                };
            }
        });
    }, [
        cloudId,
        endCursor,
        fetchMore,
        hasAnyScopeFilter,
        queryParams,
        spaceIds,
        spaceKeys
    ]);
    const refetchTasks = (0, $cozmU.useCallback)(async ()=>{
        if (!hasAnyScopeFilter) return;
        const loadedPageCount = Math.max(1, Math.ceil(rawTasks.length / safePageSize));
        const first = loadedPageCount * safePageSize;
        await refetch({
            taskQuery: {
                ...(0, $fzKPX.buildTaskQueryMetadata)(queryParams, spaceIds, spaceKeys, null),
                first: first
            },
            cloudId: cloudId
        });
    }, [
        cloudId,
        hasAnyScopeFilter,
        queryParams,
        rawTasks.length,
        refetch,
        safePageSize,
        spaceIds,
        spaceKeys
    ]);
    return {
        tasks: tasks,
        loading: loading,
        resolving: false,
        error: error,
        hasAnyScopeFilter: hasAnyScopeFilter,
        hasNextPage: hasNextPage,
        loadMore: loadMore,
        refetch: refetchTasks
    };
}


/* TasksReportTable.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Table component for the GraphQL-backed Tasks Report macro.
 *
 * Differences from the legacy TasksReportTable:
 * - Renders TaskRow rows (ADF body, ISO dates, GraphQL shape).
 * - Uses bottom page-index controls (Prev/Next + page links) while still
 *   fetching additional cursor pages on demand (AGG has no totalCount field).
 * - Column sort keys are mapped to AGG InlineTasksQuerySortColumn values.
 */ 






var $7ZB0A = parcelRequire("7ZB0A");


var $lU1vD = parcelRequire("lU1vD");





var $6mKj3 = parcelRequire("6mKj3");




const $7bf84cd6a3a239e5$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorLoading: {
        id: "tasks-report-macro.error.loading",
        defaultMessage: "Failed to load tasks. Please try again."
    },
    errorBoundaryFallback: {
        id: "tasks-report-macro.error.boundary-fallback",
        defaultMessage: "Something went wrong loading the tasks report."
    },
    noIncompleteTasksTitle: {
        id: "tasks-report-macro.empty.incomplete.title",
        defaultMessage: "No incomplete tasks found"
    },
    noCompleteTasksTitle: {
        id: "tasks-report-macro.empty.complete.title",
        defaultMessage: "No complete tasks found"
    },
    emptyDescription: {
        id: "tasks-report-macro.empty.description",
        defaultMessage: "Try adjusting your filters to find tasks."
    },
    columnDescription: {
        id: "tasks-report-macro.column.description",
        defaultMessage: "Description"
    },
    columnDueDate: {
        id: "tasks-report-macro.column.duedate",
        defaultMessage: "Due Date"
    },
    columnAssignee: {
        id: "tasks-report-macro.column.assignee",
        defaultMessage: "Assignee"
    },
    columnLocation: {
        id: "tasks-report-macro.column.location",
        defaultMessage: "Task Appears on"
    },
    columnCompleteDate: {
        id: "tasks-report-macro.column.completedate",
        defaultMessage: "Completed"
    },
    columnLabels: {
        id: "tasks-report-macro.column.labels",
        defaultMessage: "Label(s)"
    },
    completeTaskError: {
        id: "tasks-report-macro.task.complete.error",
        defaultMessage: "Failed to mark task as complete. Please try again."
    },
    completeTaskLabel: {
        id: "tasks-report-macro.task.complete.label",
        defaultMessage: "Mark task as complete"
    },
    sortAscending: {
        id: "tasks-report-macro.sort.ascending",
        defaultMessage: "Sort ascending"
    },
    sortDescending: {
        id: "tasks-report-macro.sort.descending",
        defaultMessage: "Sort descending"
    },
    paginationPrevious: {
        id: "tasks-report-macro.pagination.previous",
        defaultMessage: "Prev"
    },
    paginationNext: {
        id: "tasks-report-macro.pagination.next",
        defaultMessage: "Next"
    },
    noSpacesSelectedTitle: {
        id: "tasks-report-macro.empty.nospacesselected.title",
        defaultMessage: "No spaces selected"
    },
    noSpacesSelectedDescription: {
        id: "tasks-report-macro.empty.nospacesselected.description",
        defaultMessage: "Configure the macro and select which spaces to search for tasks."
    }
});


/* TaskRow.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * Task row renderer for the GraphQL-backed Tasks Report table.
 *
 * Key differences from the legacy TaskRow:
 * - The task description comes as ADF JSON (body.adf) instead of pre-rendered HTML.
 *   Rendered via @atlaskit/renderer ReactRenderer for full fidelity.
 * - Dates arrive as ISO strings (dueAt, createdAt, completedAt) from the AGG.
 * - Assignee / creator come as { accountId, displayName, avatarPath }.
 */ 






var $2uDbg = parcelRequire("2uDbg");


var $eNbr2 = parcelRequire("eNbr2");


var $hRnS5 = parcelRequire("hRnS5");


var $6lXol = parcelRequire("6lXol");


var $6t2Zs = parcelRequire("6t2Zs");


var $7vK9E = parcelRequire("7vK9E");











var $9wGTI = parcelRequire("9wGTI");


var $dtVue = parcelRequire("dtVue");


var $brsfB = parcelRequire("brsfB");


var $5ZqQS = parcelRequire("5ZqQS");


var $dPJCf = parcelRequire("dPJCf");








var $308Wd = parcelRequire("308Wd");

/**
 * @generated SignedSource<<ccff2ac25bce2f1adccd5fd69a1ded27>>
 * @relayHash 5dceed141e0b10467703b6bc2c2dcf88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f311289b7f26105b438dd34eea17073cd275a39182aa2ba60a6ec3f2785a8776
const $8ea67f3e9200880d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "inlineTasksInput",
                    "variableName": "input"
                }
            ],
            "concreteType": "GraphQLMutationResponse",
            "kind": "LinkedField",
            "name": "setTaskStatus",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SetTaskStatusSuccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SetTaskStatusSuccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5dceed141e0b10467703b6bc2c2dcf88",
            "id": "f311289b7f26105b438dd34eea17073cd275a39182aa2ba60a6ec3f2785a8776",
            "metadata": {},
            "name": "SetTaskStatusSuccessMutation",
            "operationKind": "mutation",
            "text": "mutation SetTaskStatusSuccessMutation($input:InlineTasksInput!){setTaskStatus(inlineTasksInput:$input){success}}"
        }
    };
}();
$8ea67f3e9200880d$var$node.hash = "1a562120f26888ee72e438dd6a1ccb9f";
var $8ea67f3e9200880d$export$2e2bcd8739ae039 = $8ea67f3e9200880d$var$node;


function $1507bd210036133c$export$488061e46b76b34a({ trigger: trigger = 'VIEW_PAGE' } = {}) {
    const [commitMutation, { loading: loading, error: error }] = (0, $308Wd.useMutationInterop)((0, $8ea67f3e9200880d$export$2e2bcd8739ae039), {
        __callerPackage__: "tasks-report-macro"
    });
    const completeTask = (0, $cozmU.useCallback)(async (contentId, taskId)=>{
        const response = await commitMutation({
            variables: {
                input: {
                    cid: contentId,
                    taskId: taskId,
                    status: 'CHECKED',
                    trigger: trigger
                }
            }
        });
        if (!response.data?.setTaskStatus?.success) throw new Error('Failed to complete task');
    }, [
        commitMutation,
        trigger
    ]);
    return {
        completeTask: completeTask,
        loading: loading,
        error: error
    };
}




const $cba7ec3456548be3$var$styles = {
    cell: "_4c065U2ADO _2Y7lL48HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1RrJLiBwqQ",
    descriptionContent: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLchRC",
    descriptionBody: "_2O5Vij7dHp",
    completionError: "_3138421Y8M _1UtDYzAyGJ",
    checkboxCell: "_0Of8r2FQfX",
    valueCellContent: "_2sNsIgmnOE"
};
const $cba7ec3456548be3$var$MISSING_COMPLETION_DATE = '--';
const $cba7ec3456548be3$var$IncompleteTaskDate = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6lXol.Date), {
        ...props,
        parentIsIncompleteTask: true
    });
const $cba7ec3456548be3$var$incompleteTaskNodeComponents = {
    date: $cba7ec3456548be3$var$IncompleteTaskDate
}; /** Format an ISO date string to a locale-aware short date, e.g. "Apr 22, 2026". */ 
function $cba7ec3456548be3$var$formatDate(iso, locale, timeZone = 'UTC') {
    if (!iso) return '';
    try {
        return new Intl.DateTimeFormat(locale, {
            timeZone: timeZone,
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).format(new Date(iso));
    } catch  {
        return iso;
    }
}
function $cba7ec3456548be3$var$renderAdf(adf, dataProviders, eventHandlers, isIncompleteTask) {
    if (!adf) return null;
    try {
        const doc = JSON.parse(adf);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t2Zs.default), {
            document: doc,
            dataProviders: dataProviders,
            eventHandlers: eventHandlers,
            nodeComponents: isIncompleteTask ? $cba7ec3456548be3$var$incompleteTaskNodeComponents : undefined
        }));
    } catch  {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, adf);
    }
}
function $cba7ec3456548be3$var$isModifiedMentionClick(event) {
    return Boolean(event?.metaKey || event?.ctrlKey || event?.button === 1);
}
const $cba7ec3456548be3$export$44f59c2c5b5f114c = ({ task: task, columns: columns, taskUpdateTrigger: taskUpdateTrigger, onTaskComplete: onTaskComplete })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "tr"
    }, columns.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "td",
            key: column,
            xcss: $cba7ec3456548be3$var$styles.cell
        }, column === 'description' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cba7ec3456548be3$export$507f2d14f9416785, {
            task: task,
            taskUpdateTrigger: taskUpdateTrigger,
            onTaskComplete: onTaskComplete
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cba7ec3456548be3$export$3836b7eb8a5b6a7b, {
            task: task,
            column: column
        }))));
};
const $cba7ec3456548be3$export$507f2d14f9416785 = ({ task: task, taskUpdateTrigger: taskUpdateTrigger, onTaskComplete: onTaskComplete })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    if (// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cba7ec3456548be3$var$TaskDescriptionCellWithProfileCard, {
        task: task,
        taskUpdateTrigger: taskUpdateTrigger,
        onTaskComplete: onTaskComplete,
        cloudId: cloudId,
        userId: userId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cba7ec3456548be3$var$TaskDescriptionCellContent, {
        task: task,
        taskUpdateTrigger: taskUpdateTrigger,
        onTaskComplete: onTaskComplete,
        cloudId: cloudId,
        userId: userId
    });
};
const $cba7ec3456548be3$var$TaskDescriptionCellWithProfileCard = ({ cloudId: cloudId, userId: userId, ...props })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cba7ec3456548be3$var$TaskDescriptionCellContent, {
        ...props,
        cloudId: cloudId,
        userId: userId,
        profilecardProvider: profilecardProvider
    });
};
const $cba7ec3456548be3$var$TaskDescriptionCellContent = ({ task: task, taskUpdateTrigger: taskUpdateTrigger, onTaskComplete: onTaskComplete, cloudId: cloudId, userId: userId, profilecardProvider: profilecardProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { completeTask: completeTask, loading: loading, error: completeTaskError } = (0, $1507bd210036133c$export$488061e46b76b34a)({
        trigger: taskUpdateTrigger
    });
    const [isCompleting, setIsCompleting] = (0, $cozmU.useState)(false);
    const [completionError, setCompletionError] = (0, $cozmU.useState)(null);
    const isMounted = (0, $cozmU.useRef)(true);
    const displayedCompletionError = completionError ?? completeTaskError;
    const adfDataProviders = (0, $cozmU.useMemo)(()=>{
        if (!cloudId || !userId) return undefined;
        const providerFactory = (0, $eNbr2.default).create({});
        providerFactory.setProvider('mentionProvider', (0, $dtVue.createMentionsConfig)(cloudId, userId).then((config)=>config.mentionResource));
        if (profilecardProvider) providerFactory.setProvider('profilecardProvider', profilecardProvider);
        return providerFactory;
    }, [
        cloudId,
        userId,
        profilecardProvider
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            adfDataProviders?.destroy();
        };
    }, [
        adfDataProviders
    ]);
    const adfEventHandlers = (0, $cozmU.useMemo)(()=>profilecardProvider ? undefined : {
            mention: {
                onClick: (mentionedUserId, _text, event)=>{
                    const targetUrl = (0, $45ad25443ac72851$export$dbeb5d178380300f)(mentionedUserId);
                    event?.preventDefault?.();
                    event?.stopPropagation?.();
                    const shouldOpenInNewTab = $cba7ec3456548be3$var$isModifiedMentionClick(event);
                    if (shouldOpenInNewTab) {
                        if (typeof window !== 'undefined') window.open(targetUrl, '_blank', 'noopener,noreferrer');
                        return;
                    }
                    push(targetUrl);
                }
            }
        }, [
        profilecardProvider,
        push
    ]);
    const handleCompleteTask = (0, $cozmU.useCallback)(async ()=>{
        if (!task.taskId || !task.container?.contentId || isCompleting || task.status === 'COMPLETE') return;
        setCompletionError(null);
        setIsCompleting(true);
        try {
            await completeTask(task.container.contentId, task.taskId);
            await onTaskComplete?.(task.id);
        } catch (error) {
            const completionErrorInstance = error instanceof Error ? error : new Error('Failed to complete task in tasks report row');
            if (isMounted.current) setCompletionError(completionErrorInstance);
            (0, $5ZqQS.getMonitoringClient)().submitError(completionErrorInstance, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
        } finally{
            if (isMounted.current) setIsCompleting(false);
        }
    }, [
        completeTask,
        isCompleting,
        onTaskComplete,
        task.container?.contentId,
        task.id,
        task.status,
        task.taskId
    ]);
    const handleCompleteTaskCheckboxChange = (0, $cozmU.useCallback)((event)=>{
        if (event.currentTarget.checked) handleCompleteTask();
    }, [
        handleCompleteTask
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cba7ec3456548be3$var$styles.descriptionContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cba7ec3456548be3$var$styles.checkboxCell
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: task.status === 'COMPLETE' || isCompleting,
        onChange: handleCompleteTaskCheckboxChange,
        isDisabled: task.status === 'COMPLETE' || isCompleting || loading,
        "aria-label": formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).completeTaskLabel),
        testId: `task-complete-checkbox-${task.taskId}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cba7ec3456548be3$var$styles.descriptionBody
    }, $cba7ec3456548be3$var$renderAdf(task.adf, adfDataProviders, adfEventHandlers, task.status === 'INCOMPLETE'), displayedCompletionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cba7ec3456548be3$var$styles.completionError,
        role: "alert"
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).completeTaskError)) : null));
};
const $cba7ec3456548be3$export$3836b7eb8a5b6a7b = ({ task: task, column: column })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const locationUrl = (0, $45ad25443ac72851$export$c254a30a66ea69b8)(task.container?.url);
    let content = '';
    switch(column){
        case 'duedate':
            // Task due dates are stored as midnight in the tenant timezone, then serialized as UTC.
            // Format them back in the tenant timezone to preserve the selected calendar date.
            content = $cba7ec3456548be3$var$formatDate(task.dueAt, locale, tenantTimeZone ?? 'UTC');
            break;
        case 'completedate':
            if (task.completedAt) content = $cba7ec3456548be3$var$formatDate(task.completedAt, locale);
            else if (task.status === 'COMPLETE') content = $cba7ec3456548be3$var$MISSING_COMPLETION_DATE;
            break;
        case 'assignee':
            content = task.assignedTo?.displayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                href: (0, $45ad25443ac72851$export$dbeb5d178380300f)(task.assignedTo.accountId)
            }, task.assignedTo.displayName) : '';
            break;
        case 'location':
            content = locationUrl && task.container?.title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                href: locationUrl
            }, task.container.title) : task.container?.title ?? '';
            break;
        case 'labels':
            content = (task.container?.labels ?? []).join(', ');
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cba7ec3456548be3$var$styles.valueCellContent
    }, content);
};


const $273ee89019646427$var$SORTABLE_COLUMNS = [
    'duedate',
    'assignee',
    'location'
];
const $273ee89019646427$var$COLUMN_LABEL_MESSAGES = {
    description: (0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).columnDescription,
    duedate: (0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).columnDueDate,
    assignee: (0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).columnAssignee,
    location: (0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).columnLocation,
    completedate: (0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).columnCompleteDate,
    labels: (0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).columnLabels
};
const $273ee89019646427$var$styles = {
    tableWrapper: "_4bt5LAIZbP _39xV02N91d",
    paginationControls: "_2mHwu82ADO _3iDTPbQ4SZ _37wbyuDIqT _3138422ADO"
};
function $273ee89019646427$var$getColumnLabel(column, formatMessage) {
    return formatMessage($273ee89019646427$var$COLUMN_LABEL_MESSAGES[column]);
}
function $273ee89019646427$var$buildTableRow(task, columns, serverSortPosition, taskUpdateTrigger, onTaskComplete) {
    const cells = [];
    for (const column of columns){
        const content = column === 'description' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cba7ec3456548be3$export$507f2d14f9416785), {
            task: task,
            taskUpdateTrigger: taskUpdateTrigger,
            onTaskComplete: onTaskComplete
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cba7ec3456548be3$export$3836b7eb8a5b6a7b), {
            task: task,
            column: column
        });
        cells.push({
            key: serverSortPosition ?? `${task.id}-${column}`,
            content: content
        });
    }
    return {
        key: task.id,
        cells: cells
    };
}
const $273ee89019646427$export$db3cc8bf6b7b2ace = ({ tasks: tasks, columns: columns, currentSortBy: currentSortBy, currentReverseSort: currentReverseSort, pageSize: pageSize, hasNextPage: hasNextPage, loadingMore: loadingMore, onSort: onSort, onLoadMore: onLoadMore, taskUpdateTrigger: taskUpdateTrigger, onTaskComplete: onTaskComplete })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tableSortOrder = currentReverseSort ? 'ASC' : 'DESC'; // Combine currentPage and pendingLoadMore into one state object so all
    // related updates are atomic — avoids chained state setter calls which
    // cause extra re-renders and violate the no-chain-state-updates lint rule.
    const [pageState, setPageState] = (0, $cozmU.useState)({
        currentPage: 1,
        pendingLoadMore: false
    });
    const { currentPage: currentPage, pendingLoadMore: pendingLoadMore } = pageState;
    const previousLoadingMoreRef = (0, $cozmU.useRef)(loadingMore);
    const loadedPages = Math.max(1, Math.ceil(tasks.length / pageSize));
    const effectivePage = Math.min(currentPage, loadedPages); // Tasks arrive pre-sorted from the server. Slice the current page from the
    // accumulated list (which grows as the user loads more cursor pages).
    const pageTasks = (0, $cozmU.useMemo)(()=>{
        const startIndex = (effectivePage - 1) * pageSize;
        return tasks.slice(startIndex, startIndex + pageSize);
    }, [
        effectivePage,
        pageSize,
        tasks
    ]); // Reset to page 1 when the user changes sort — the renderer re-queries the
    // server, which resets the task list to the first page of results.
    // Also cancel any in-flight loadMore so the reactive effect doesn't
    // incorrectly advance the page when the new (smaller) task list arrives.
    (0, $cozmU.useEffect)(()=>{
        setPageState({
            currentPage: 1,
            pendingLoadMore: false
        });
    }, [
        currentSortBy,
        currentReverseSort
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (tasks.length <= pageSize) setPageState({
            currentPage: 1,
            pendingLoadMore: false
        });
    }, [
        tasks,
        pageSize
    ]);
    const tableHead = (0, $cozmU.useMemo)(()=>({
            cells: columns.map((column)=>({
                    key: column,
                    content: $273ee89019646427$var$getColumnLabel(column, formatMessage),
                    isSortable: $273ee89019646427$var$SORTABLE_COLUMNS.includes(column)
                }))
        }), [
        columns,
        formatMessage
    ]);
    const tableRows = (0, $cozmU.useMemo)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_tasks_report_preserve_server_sort', 'isEnabled', true)) {
            const sortDirection = tableSortOrder === 'ASC' ? 1 : -1;
            return pageTasks.map((task, index)=>$273ee89019646427$var$buildTableRow(task, columns, sortDirection * index, taskUpdateTrigger, onTaskComplete));
        }
        return pageTasks.map((task)=>$273ee89019646427$var$buildTableRow(task, columns, undefined, taskUpdateTrigger, onTaskComplete));
    }, [
        columns,
        onTaskComplete,
        pageTasks,
        tableSortOrder,
        taskUpdateTrigger
    ]);
    const handleTableSort = (0, $cozmU.useCallback)(({ key: key })=>{
        if (typeof key !== 'string') return;
        if (!$273ee89019646427$var$SORTABLE_COLUMNS.includes(key)) return;
        onSort(key);
    }, [
        onSort
    ]);
    const handlePrevious = (0, $cozmU.useCallback)(()=>{
        if (currentPage <= 1) return;
        setPageState({
            currentPage: currentPage - 1,
            pendingLoadMore: false
        });
    }, [
        currentPage
    ]);
    const handleNext = (0, $cozmU.useCallback)(()=>{
        if (currentPage < loadedPages) {
            setPageState({
                currentPage: currentPage + 1,
                pendingLoadMore: false
            });
            return;
        }
        if (hasNextPage && !loadingMore && !pendingLoadMore) {
            // Navigating beyond loaded data — fire the fetch but keep currentPage
            // pointing at the last loaded page. The effect below will advance
            // currentPage once the new data arrives, preventing a blank-table flash.
            setPageState({
                currentPage: currentPage,
                pendingLoadMore: true
            });
            onLoadMore();
        }
    }, [
        currentPage,
        hasNextPage,
        loadingMore,
        loadedPages,
        onLoadMore,
        pendingLoadMore
    ]); // Reactively advance to the next page once the fetch triggered by onLoadMore()
    // has resolved and tasks.length has grown to cover that page. This avoids the
    // blank-table flash that occurs when currentPage advances eagerly before data
    // is available.
    (0, $cozmU.useEffect)(()=>{
        if (pendingLoadMore && tasks.length > currentPage * pageSize) setPageState({
            currentPage: currentPage + 1,
            pendingLoadMore: false
        });
    }, [
        currentPage,
        pageSize,
        pendingLoadMore,
        tasks.length
    ]);
    (0, $cozmU.useEffect)(()=>{
        const didFinishLoadingMore = previousLoadingMoreRef.current && !loadingMore;
        if (pendingLoadMore) {
            const didReceiveNewPage = tasks.length > currentPage * pageSize;
            const noMoreResults = !hasNextPage;
            const didNotReceiveNewPage = tasks.length <= currentPage * pageSize;
            if (!didReceiveNewPage && (noMoreResults || didFinishLoadingMore && didNotReceiveNewPage)) setPageState({
                currentPage: currentPage,
                pendingLoadMore: false
            });
        }
        previousLoadingMoreRef.current = loadingMore;
    }, [
        currentPage,
        hasNextPage,
        loadingMore,
        pageSize,
        pendingLoadMore,
        tasks.length
    ]);
    const canGoPrevious = currentPage > 1;
    const canGoNext = currentPage < loadedPages || hasNextPage;
    const isPreviousDisabled = !canGoPrevious;
    const isNextDisabled = !canGoNext || loadingMore || pendingLoadMore;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "tasks-report-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $273ee89019646427$var$styles.tableWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU1vD.default), {
        head: tableHead,
        rows: tableRows,
        onSort: handleTableSort,
        sortKey: currentSortBy,
        sortOrder: tableSortOrder,
        testId: "tasks-report-table"
    })), (canGoPrevious || canGoNext) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $273ee89019646427$var$styles.paginationControls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        testId: "tasks-report-prev-button",
        onClick: handlePrevious,
        isDisabled: isPreviousDisabled
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).paginationPrevious)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        testId: "tasks-report-next-button",
        onClick: handleNext,
        isDisabled: isNextDisabled
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).paginationNext))));
};


/* EmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $dinVW = parcelRequire("dinVW");


const $5337833e6b977173$var$styles = {
    container: "_4FKVYENHnM _2fwxA5DIqT",
    title: "_2sNsIgd8bj _1kk5Tk7GSX",
    description: "_2sNsIgmnOE _1UtDYzKGUX"
};
const $5337833e6b977173$export$fddf379e22a74b00 = ({ status: status, noSpacesSelected: noSpacesSelected })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (noSpacesSelected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5337833e6b977173$var$styles.container,
        testId: "tasks-report-empty-state-no-spaces"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5337833e6b977173$var$styles.title
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).noSpacesSelectedTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5337833e6b977173$var$styles.description
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).noSpacesSelectedDescription))));
    const title = status === 'complete' ? formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).noCompleteTasksTitle) : formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).noIncompleteTasksTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5337833e6b977173$var$styles.container,
        testId: "tasks-report-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5337833e6b977173$var$styles.title
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5337833e6b977173$var$styles.description
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).emptyDescription))));
};



const $d035459a8461076d$var$styles = {
    container: "_3iDTPbvLZJ _39xV02N91d",
    loading: "_3iDTPbQ4SZ _37wbyuDIqT _0Of8r2NHnM _1wydGWNHnM"
};
const $d035459a8461076d$var$TasksReportMacroRendererComponent = ({ macroDefaultProps: macroDefaultProps, macroParams: macroParams })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const params = (0, $cozmU.useMemo)(()=>(0, $rPmsQ.parseMacroParams)(macroParams), [
        macroParams
    ]);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node } = macroDefaultProps;
    const attributes = macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const experienceName = (0, $5kjCz.getExperienceName)(mode, node); // Track sort state locally so the user can click column headers without
    // changing the macro definition. Reset to macro defaults when params change
    // (e.g. macro is re-configured). Stored as a single object to avoid chained
    // state updates (no-chain-state-updates lint rule).
    const [sortState, setSortState] = (0, $cozmU.useState)({
        sortBy: params.sortBy,
        reverseSort: params.reverseSort
    });
    (0, $cozmU.useEffect)(()=>{
        setSortState({
            sortBy: params.sortBy,
            reverseSort: params.reverseSort
        });
    }, [
        params.sortBy,
        params.reverseSort
    ]);
    const effectiveParams = (0, $cozmU.useMemo)(()=>({
            ...params,
            sortBy: sortState.sortBy,
            reverseSort: sortState.reverseSort
        }), [
        params,
        sortState
    ]);
    const taskUpdateTrigger = (0, $cozmU.useMemo)(()=>{
        switch(macroDefaultProps.mode){
            case 'editor':
                return 'EDIT_PAGE';
            case 'renderer':
                return 'VIEW_PAGE';
            default:
                return 'UNKNOWN';
        }
    }, [
        macroDefaultProps.mode
    ]);
    const { tasks: tasks, loading: loading, resolving: resolving, error: error, hasAnyScopeFilter: hasAnyScopeFilter, hasNextPage: hasNextPage, loadMore: loadMore, refetch: refetch } = (0, $35db60b89e0f9281$export$6e0f38053ef16fcf)({
        params: effectiveParams,
        cloudId: cloudId
    });
    // Optimistically hide tasks that the user has just completed so they
    // disappear immediately while the refetch is in flight.
    const [optimisticallyHiddenTaskIds, setOptimisticallyHiddenTaskIds] = (0, $cozmU.useState)(()=>new Set());
    const visibleTasks = (0, $cozmU.useMemo)(()=>{
        if (optimisticallyHiddenTaskIds.size === 0) return tasks;
        return tasks.filter((task)=>!optimisticallyHiddenTaskIds.has(task.id));
    }, [
        optimisticallyHiddenTaskIds,
        tasks
    ]);
    const handleTaskComplete = (0, $cozmU.useCallback)(async (taskId)=>{
        setOptimisticallyHiddenTaskIds((previousHiddenIds)=>{
            if (previousHiddenIds.has(taskId)) return previousHiddenIds;
            const nextHiddenIds = new Set(previousHiddenIds);
            nextHiddenIds.add(taskId);
            return nextHiddenIds;
        });
        try {
            await refetch();
        } finally{
            setOptimisticallyHiddenTaskIds((previousHiddenIds)=>{
                if (!previousHiddenIds.has(taskId)) return previousHiddenIds;
                const nextHiddenIds = new Set(previousHiddenIds);
                nextHiddenIds.delete(taskId);
                return nextHiddenIds;
            });
        }
    }, [
        refetch
    ]);
    // sortKey is a macro param string (e.g. 'duedate'), not an AGG enum.
    // The hook maps it to the correct GraphQL enum value internally.
    // Both sortBy and reverseSort are updated together in a single setState call
    // to satisfy the no-chain-state-updates lint rule.
    const handleSort = (0, $cozmU.useCallback)((sortKey)=>{
        setSortState((prev)=>({
                sortBy: sortKey,
                reverseSort: prev.sortBy === sortKey ? !prev.reverseSort : false
            }));
    }, []);
    if ((loading || resolving) && visibleTasks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d035459a8461076d$var$styles.loading,
        testId: "tasks-report-loading",
        "data-render-path": "rewrite-graphql"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium"
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes,
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).errorLoading)));
    if (!loading && !resolving && visibleTasks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5337833e6b977173$export$fddf379e22a74b00), {
        status: params.status,
        noSpacesSelected: !hasAnyScopeFilter
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d035459a8461076d$var$styles.container,
        testId: "tasks-report-macro-container",
        "data-render-path": "rewrite-graphql",
        "data-fabric-macro": macroDefaultProps?.attributes?.macroId,
        "data-macro-body": ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $273ee89019646427$export$db3cc8bf6b7b2ace), {
        tasks: visibleTasks,
        columns: params.columns,
        currentSortBy: sortState.sortBy,
        currentReverseSort: sortState.reverseSort,
        pageSize: params.pageSize,
        hasNextPage: hasNextPage,
        loadingMore: loading,
        taskUpdateTrigger: taskUpdateTrigger,
        onSort: handleSort,
        onLoadMore: loadMore,
        onTaskComplete: handleTaskComplete
    }));
};
const $d035459a8461076d$export$34b7d9df34516dd9 = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderErrorFallback = (0, $cozmU.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, formatMessage((0, $7bf84cd6a3a239e5$export$a7357cdd1f0b0168).errorBoundaryFallback)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d035459a8461076d$var$TasksReportMacroRendererComponent, props));
};
module.exports["TasksReportMacroRenderer"] = $d035459a8461076d$export$34b7d9df34516dd9;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});


//# sourceMappingURL=TasksReportMacroRenderer.7adfc9fa.js.map
